import { mapActions } from 'pinia';
import {
  useModalStore,
} from '@/stores';
import * as types from '@/lib/constants/store';

const MIN_MODAL_OPEN_TIME = 750;

export default {
  methods: {
    ...mapActions(useModalStore, [
      types.OPEN_MODAL,
      types.CLOSE_MODAL,
    ]),
    openModalDeferred(delay, modal) {
      let closed = false;
      let modalOpenTime;
      const close = (onClose) => {
        if (!closed) {
          const currentTime = (new Date()).getTime();
          let closeModalDelay = 0;
          /*
            If the modal is open when we call close, make sure it stays
            open for a minimum amount of time to avoid flicker effect in UI.
          */
          if (modalOpenTime) {
            const modalVisibleFor = currentTime - modalOpenTime;
            if (modalVisibleFor < MIN_MODAL_OPEN_TIME) {
              closeModalDelay = MIN_MODAL_OPEN_TIME - modalVisibleFor;
            }
          }
          closed = true;
          setTimeout(() => {
            this[types.CLOSE_MODAL]({ id: modal.id });
            if (onClose) {
              onClose();
            }
          }, closeModalDelay);
        }
      };
      setTimeout(() => {
        if (!closed) {
          this[types.OPEN_MODAL](modal);
          modalOpenTime = (new Date()).getTime();
        }
      }, delay);
      return {
        close,
      };
    },
  },
};
